import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/thruster.js';
      import {InstrumentState, Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
import {LinearAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/advice.js';
import {PropellerType} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/propeller.js';

      export interface Props {
     thrust?: number;
     state?: InstrumentState;
     priority?: Priority;
     tunnel?: boolean;
     singleSided?: boolean;
     singleDirection?: boolean;
     singleDirectionHalfSize?: boolean;
     advices?: LinearAdvice[];
     topPropeller?: PropellerType;
     bottomPropeller?: PropellerType;
     setpoint?: number | undefined;
     newSetpoint?: number | undefined;
     atSetpoint?: boolean;
     touching?: boolean;
     autoAtSetpoint?: boolean;
     autoAtSetpointDeadband?: number;
     setpointAtZeroDeadband?: number;
     setpointOverride?: boolean;
     animateSetpoint?: boolean
   }

      
  
      export type {InstrumentState, Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
export type {LinearAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/advice.js';
export type {PropellerType} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/propeller.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcThruster',
  props: {
    thrust: {},
    state: {},
    priority: {},
    tunnel: { type: Boolean },
    singleSided: { type: Boolean },
    singleDirection: { type: Boolean },
    singleDirectionHalfSize: { type: Boolean },
    advices: {},
    topPropeller: {},
    bottomPropeller: {},
    setpoint: {},
    newSetpoint: {},
    atSetpoint: { type: Boolean },
    touching: { type: Boolean },
    autoAtSetpoint: { type: Boolean },
    autoAtSetpointDeadband: {},
    setpointAtZeroDeadband: {},
    setpointOverride: { type: Boolean },
    animateSetpoint: { type: Boolean }
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-thruster',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})